/* src/app/external-user/invoice-details/invoice-details.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.cc_details_loading {
  float: right;
  margin-top: 30px;
  margin-right: 20px;
}
.ach_details_loading {
  float: right;
  margin-top: 30px;
  margin-right: 20px;
}
.row {
  margin: 0px;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.userbtn_main {
  margin-top: -60px;
  position: absolute;
  right: 0px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu > li > a:hover {
  background-color: #008ad0;
  color: #ffffff;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.below_header {
  padding: 10px;
}
.invoice_id {
  font-size: 20px;
  float: left;
  padding: 10px;
}
.invoice_icon {
  padding: 10px 0px;
  color: #040404;
  border-radius: 4px;
  font-size: 30px !important;
  font-weight: bold !important;
  float: left;
}
.invoice_textarea {
  float: left;
  padding: 9px 0px;
}
.invoice_textarea_body {
  background: none;
  border: none;
  resize: none;
  font-size: 13px;
  color: #000;
  height: 50px;
  max-height: 250px;
}
.detail_list {
  margin-top: 10px;
  clear: both;
  white-space: nowrap;
  padding-left: 22px;
}
.payment_detail_main {
  margin-top: 25px;
  clear: both;
}
.payment_detailtxt {
  font-size: 20px;
  font-weight: 500;
  padding: 0px 5px;
}
.payment_detail_icon {
  padding: 10px 0px;
  color: #040404;
  border-radius: 4px;
  font-size: 30px !important;
  font-weight: bold !important;
}
.full_payment {
  font-size: 14px;
  float: left;
  margin: -2px 10px;
  color: #040404;
}
.checkbox_modified {
  left: 0px !important;
  opacity: 1 !important;
  margin-left: inherit !important;
  font-size: 23px;
  color: #000000;
  float: left;
  position: relative !important;
  width: 20px;
  height: 30px;
  margin-top: -8px !important;
  padding: 20px;
}
.input_number {
  float: left;
  margin-top: -14px;
}
.input_numberinput {
  border: none;
  background: transparent;
  border-bottom: 1px solid #c7c7c7;
  outline: none;
  width: 100px;
  text-align: right;
}
.ach_main {
  margin: 10px 0px;
}
.ach_main_left {
  float: left;
  text-align: left;
}
.ach_main_right {
  margin-right: 3px;
  float: right;
  font-weight: bold;
  text-align: right;
}
.achbtn_main {
  float: right;
  clear: both;
}
.achbtn_modifi {
  background-color: #0f9c00;
  color: #ffffff;
  border-radius: 30px;
  padding: 0px 15px;
  text-transform: unset;
  margin-right: -20px;
}
.btn:hover {
  color: #ffffff;
}
.cc_main {
  margin: 0px 0px;
  float: right;
}
.cc_main_left {
  float: left;
  text-align: left;
}
.cc_main_right {
  float: right;
  text-align: right;
  font-weight: bold;
}
.ccbtn_main {
  float: right;
  clear: both;
}
.ccbtn_modifi {
  background-image: url(/assets/images/american_express-512.png);
  color: #ffffff;
  border-radius: 30px;
  padding: 0px 15px;
  text-transform: unset;
  width: 103px;
  background-repeat: no-repeat;
  background-size: 130px;
  background-position: center;
  margin-right: -20px;
}
.break_line {
  border-right: 1px solid #b1b1b1;
  height: 100px;
  margin-top: 20px;
}
.input-ErrorField {
  font-size: 12px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  margin-top: 0px;
  border-bottom-color: #fff !important;
  color: #cc0000 !important;
  height: 36px;
  background: transparent;
  position: relative;
}
.currencyinput {
  border: 1px inset #ccc;
  padding-bottom: 1px;
}
.goback {
  background-color: #028ba3;
  float: left;
  color: #fff;
  padding: 15px 20px;
  border-radius: 30px;
  cursor: pointer;
  height: auto;
  line-height: 0px;
  text-transform: unset;
  outline: none;
}
.goback:hover {
  color: #fff;
  background-color: #028ba3;
}
.recalc_modifi {
  margin-top: -7px;
  background-color: #028ba3;
  padding: 15px 10px;
  border-radius: 30px;
  text-transform: capitalize;
  margin-left: 41px;
  outline: none;
  line-height: 0px;
  height: 0px;
}
.recalc_modifi:hover {
  color: #fff;
  background-color: #028ba3;
}
.recalc_modifi:focus {
  color: #fff;
  background-color: #028ba3;
}
.recalc_modifi:disabled {
  pointer-events: none;
  background-color: #DFDFDF !important;
  box-shadow: none;
  color: #9F9F9F !important;
  cursor: default;
}
@media (min-width: 300px) and (max-width: 600px) {
  .input-ErrorField {
    margin-top: -10px;
    float: left;
  }
  .input_numberinput {
    border: none;
    background: transparent;
    border-bottom: 1px solid #c7c7c7;
    outline: none;
    width: 109px;
    font-size: 12px;
  }
  .recalc_modifi {
    margin-left: 0px;
    margin-top: -3px;
    padding: 10px 5px;
    border-radius: 30px;
    float: right;
    font-size: 10px;
    height: auto;
    line-height: 0px;
  }
  .ach_main_left {
    float: left;
    text-align: left;
    font-size: 10px;
  }
  .ach_main_right {
    margin-left: 0px;
    float: right;
    font-size: 10px;
    margin-right: 0px;
  }
  .ach_main {
    font-size: 10px;
  }
  .achbtn_main {
    margin-right: 0px;
  }
  .achbtn_modifi {
    margin-right: 0px;
  }
  .cc_main_left {
    float: left;
    text-align: left;
    font-size: 10px;
  }
  .cc_main_right {
    margin-left: 0px;
    float: right;
  }
  .cc_main {
    font-size: 10px;
    margin: 20px 0px;
    float: left;
  }
  .ccbtn_main {
    margin-right: 0px;
  }
  .user_main {
    padding: 15px 28px 7px 0px;
  }
  .logo {
    padding: 25px 14px 0px 25px;
  }
  .row {
    margin-right: -15px;
    margin-left: -15px;
  }
  .invoice_textarea_body,
  .detail_list {
    padding-left: 0 !important;
  }
  .detail_list span {
    margin-left: 0;
    padding-left: 0;
  }
  .detail_list span b + b {
    padding-left: 20px !important;
  }
}
@media (max-width: 900px) and (min-width: 600px) {
  .cc_main {
    padding-top: 10px;
  }
  .ach_main_right {
    margin-right: 0px;
  }
  .achbtn_modifi {
    margin-right: 0px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px !important;
  }
}
@media only screen and (min-width: 993px) {
  .container {
    width: 100%;
  }
}
/*# sourceMappingURL=invoice-details.component.css.map */
